import { PointOfInterest } from './poi';
import { LookUp } from './data-models';

export class Sensor {
    Id: number;
    TrackedObjectId: number;
    SensorName: string;
    MainsensorTypeId: number = -1;
    SensorTypeId: number = -1;
    SensorType: LookUp = new LookUp();
    PortNumber: number = -1;
    DigitalValueId?: number = -1;
    DigitalValue: LookUp = new LookUp();
    DigitalValueNameId?: number = -1;
    DigitalValueName: LookUp = new LookUp();
    SensorUnitId?: number = -1;
    SensorUnit: LookUp = new LookUp();
    TransporterId: number;
    IsDeleted: boolean;
    SubscriberId: number = 1;
    CreatedBy: number;
    CreationDate: Date;
    LastUpdatedBy?: number;
    LastUpdatedDate?: Date;
    isSelected: boolean = false;
    EventNameForZeroDigit: any = '';
    EventNameForOneDigit: any = '';
    IsCustom: boolean = false;
    CustomName: any = '';
    IsShowEquation: boolean = false;
    ShowEquationValue: boolean = false;
    X4Value: string = "0";
    X3Value: string = "0";
    X2Value: string = "0";
    X1Value: string = "0";
    ConstantValue: string = "0";
    AnalogNumber: number = 0;
    DigitNumber: number = 0;
    WireNumber: number = 0;
    ShowCanBus: boolean = false;
    SensorNameExpression: string = "";
}

export enum MainSensorType {
    analog = 1,
    digital = 2
}

export class Canbus {
    PropertyId: number;
    SensorId: number;
    SensorName: string;
    SensorTypeId: number;
    SensorType: string;
}

export class VehicleCanbus {
    TrackedObjectId: number;
    ModelId: number;
    SensorCanbusDTO: Canbus[];
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/sensors-tab-form.ts